import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { MessagesService } from 'src/app/Services/Messages/messages.service';
// interface DialogData {
//   filearr: any;
// }
@Component({
  selector: 'app-viewzipfiles',
  templateUrl: './viewzipfiles.component.html',
  styleUrls: ['./viewzipfiles.component.css']
})

export class ViewzipfilesComponent implements OnInit {
  filarr;

  constructor(
    private dialog: MatDialog, private msgservice: MessagesService,
    @Inject(MAT_DIALOG_DATA) public dmObj: any, public dialogRef: MatDialogRef<ViewzipfilesComponent>
    , private sanitizer: DomSanitizer) {
    if (dmObj) {
      this.filarr = dmObj.filearr;
    }

  }

  ngOnInit() {
  }
  filedata: any = null;
  fileurl: any = null;
  iscda: boolean = false;
  onfileclick(element) {
    this.iscda = false;
    var re = /href=/gi;
    this.filedata = element.filedata.replace(re, "");
    if (this.filedata.includes('<ClinicalDocument')) {
      this.iscda = true;
      this.msgservice.getCDATOHTMLDetails(this.filedata).subscribe(data => {
        this.fileurl = this.sanitizer.bypassSecurityTrustHtml(data);
      }, (err: any) => {
        console.log(err);
      });
    }
  }

  onCancelClick() {
    this.dialogRef.close();
  }
}
